import React from "react";
import { ThumbsUp } from "lucide-react";
import { toast } from "sonner";

export default function DeliveryRating({
  isAdminView,
  isDelivered,
  showRatingSection,
  existingRating,
  loadingRating,
  driverRating,
  setDriverRating,
  customerMessage,
  setCustomerMessage,
  ratingSubmitting,
  submitDeliveryRating,
  ratingDismissed,
  dismissRating,
}) {
  // Don't show if not delivered, rating already submitted, or user dismissed it
  if (!isDelivered || !showRatingSection || ratingDismissed) return null;

  /* EXISTING RATING  */
  if (existingRating) {
    return (
      <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl p-4">
        <div className="flex items-center justify-center gap-3 mb-2">
          <ThumbsUp size={18} />
          <p className="font-semibold">Your delivery rating</p>
        </div>

        <div className="flex gap-1 mb-2 justify-center">
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={`text-lg ${
                star <= Number(existingRating.rating)
                  ? "text-orange-500"
                  : "text-gray-300"
              }`}
            >
              ⭐
            </span>
          ))}
        </div>

        {existingRating.customer_message && (
          <p className="text-sm text-gray-600 italic flex justify-center">
            "{existingRating.customer_message}"
          </p>
        )}
      </div>
    );
  }

  if (loadingRating) return null;

  if (isAdminView) return null;

  return (
    <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl p-4 pb-0">
      <div className="flex items-start gap-4 mb-4">
        <div className="p-3 rounded-full bg-gray-100">
          <ThumbsUp size={18} />
        </div>

        <div>
          <p className="font-semibold mb-1">
            How was your delivery experience?
          </p>
          <p className="text-sm text-gray-500">Rate your delivery partner</p>
        </div>
      </div>

      {/* STARS */}
      <div className="flex gap-2 mb-3">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            onClick={() => setDriverRating(star)}
            className={`flex-1 py-2 rounded-lg text-sm font-semibold border
              ${
                driverRating === star
                  ? "bg-orange-500 text-white border-orange-500"
                  : "bg-white text-gray-600"
              }`}
          >
            {star} ⭐
          </button>
        ))}
      </div>

      <textarea
        value={customerMessage}
        onChange={(e) => setCustomerMessage(e.target.value)}
        placeholder="Write a short feedback (optional)"
        rows={2}
        className="w-full text-sm border rounded-lg p-3 resize-none
          focus:outline-none focus:ring-2 focus:ring-orange-500"
      />

      <div className="-mx-4 bg-orange-100 pt-[4px] flex gap-[5px] mt-4">
        <button
          onClick={() => {
            dismissRating();
            toast.info("You can rate later");
          }}
          className="w-1/2 py-3 text-sm text-orange-500 font-medium bg-white rounded-bl-xl cursor-pointer [&:hover]:transform-none [&:hover]:scale-100"
          style={{ transition: "none" }}
        >
          Maybe later
        </button>

        <button
          onClick={submitDeliveryRating}
          disabled={ratingSubmitting}
          className={`w-1/2 py-3 text-sm font-medium rounded-br-xl [&:hover]:transform-none [&:hover]:scale-100
      ${
        ratingSubmitting
          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
          : "bg-orange-500 text-white cursor-pointer"
      }`}
          style={{ transition: "none" }}
        >
          {ratingSubmitting ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  );
}
